// tslint:disable-next-line:whitespace
(() => {
  const css =
    // tslint:disable-next-line:max-line-length
    'html {overflow-x: hidden; } body { margin: 0px; padding: 0; position: relative; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; } .EmptyMasterContentPanel { height: 100% !important } .height100PImportant { height: 100% !important }'
  const head = document.head || document.getElementsByTagName('head')[0]
  const style = document.createElement('style')

  style.type = 'text/css'
  style.appendChild(document.createTextNode(css))
  head.appendChild(style)
})()
